import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffect } from './auth.effects';
import { authReducer } from './auth.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('AUTH', authReducer), EffectsModule.forFeature([AuthEffect])],
  exports: [],
})
export class AuthStoreModule {}
